import { Component, HostListener, isDevMode } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { UatBannerComponent } from './layout/common/uat-banner/uat-banner.component';
import { GlobalConfigService } from "./services/global-config.service";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [RouterOutlet, UatBannerComponent],
})
export class AppComponent {
    /**
     * Constructor
     */
    constructor(
        private _globalConfigService: GlobalConfigService
    ) {
    }

    @HostListener('window:keydown', ['$event'])
    onShiftClick(event: KeyboardEvent): void {
        if (isDevMode()) {
            if (event.ctrlKey && event.shiftKey) {
                this._globalConfigService.demoMode$.next(!this._globalConfigService.demoMode$.value);
            }
        }
    }
}
